var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C4.03763 18 0 13.9624 0 9C0 4.03763 4.03763 0 9 0C13.9624 0 18 4.03763 18 9C18 13.9624 13.9624 18 9 18ZM9 1.125C4.6575 1.125 1.125 4.6575 1.125 9C1.125 13.3425 4.6575 16.875 9 16.875C13.3425 16.875 16.875 13.3425 16.875 9C16.875 4.6575 13.3425 1.125 9 1.125ZM9.5625 5.0625C9.5625 5.37316 9.31066 5.625 9 5.625C8.68934 5.625 8.4375 5.37316 8.4375 5.0625C8.4375 4.75184 8.68934 4.5 9 4.5C9.31066 4.5 9.5625 4.75184 9.5625 5.0625ZM9 13.4981C8.6895 13.4981 8.4375 13.2467 8.4375 12.9356V7.3125C8.4375 7.002 8.6895 6.75 9 6.75C9.3105 6.75 9.5625 7.002 9.5625 7.3125V12.9356C9.5625 13.2467 9.3105 13.4981 9 13.4981Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentInfo);
export default __webpack_public_path__ + "static/media/transparent-info.d2f5a4c99e57bdd69f4a2c18b580e396.svg";
export { ForwardRef as ReactComponent };